// extracted by mini-css-extract-plugin
module.exports = {"select":"SeasonSelect_select__3g9QC"};